import * as React from 'react'
import * as gql from 'graphql/types'
import { useMutation, useQuery } from '@apollo/client'
import insights from 'graphql/queries/insights'
import invalidateCurrentInsight from 'graphql/mutations/invalidateCurrentInsight'
import * as css from '../User.styles'
import { Button, ButtonBase, Checkbox, InputLabel, MenuItem, Select } from '@material-ui/core'
import { CdrEnergyButtons } from './cdrEnergyButtons'
import { CdrUsageButtons } from './cdrUsageButtons'
import { useParams } from 'react-router-dom'

type Props = {
    user: gql.User
    userAttributes: gql.UserAttribute[]
}

const Insights = ({ user, userAttributes }: Props) => {
    const { insight_id } = useParams<any>()
    const [showAll, setShowAll] = React.useState(false)
    const [filterDomain, setFilterDomain] = React.useState("all")
    const { loading, error, data, refetch } = useQuery(insights, {
        variables: { UserID: user.user_id, All: 'true' },
    })
    const [r] = useMutation(invalidateCurrentInsight)
    React.useEffect(() => {
        if (insight_id) {
            setShowAll(true)
        }
    } , [insight_id])
    if (loading) return <></>
    if (error) {
        console.log(error.message)
        return <></>
    }
    const handleDelete = async (insight: gql.Insight) => {
        await r({
            variables: {
                UserID: user.user_id,
                Domain: insight.Domain,
            },
        })
        await refetch()
    }
    
    let insightData = data.insights
    if (!showAll && insightData) insightData = insightData.filter((a) => a.Current == 'true')
    insightData = [...insightData].sort((a, b) => {
        const first = Date.parse(a.GeneratedAt.substring(0, 19))
        const second = Date.parse(b.GeneratedAt.substring(0, 19))
        return second - first
    })
    if (filterDomain !== 'all') {
        insightData = insightData.filter((a) => a.Domain === filterDomain
        )
    }
    const cdrConnected = userAttributes.find((a) => a.key === 'fiskilConnected')?.value === 'true'
    return (
        <div className={css.container}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', marginBottom: '10px' }}>
                <div style={{ marginLeft: '20px', padding: '5px', border: '1px solid grey', paddingRight: '30px' }}>
                    <Checkbox
                        checked={showAll}
                        onChange={() => setShowAll(!showAll)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />{' '}
                    Show all
                </div>
                { cdrConnected && (
                    
                    <div style={{ marginLeft: '20px', padding: '5px', border: '1px solid grey' }}>
                        <div>CDR Connected</div>
                        <CdrEnergyButtons userID={user.user_id} />
                        <CdrUsageButtons />
                    </div>
                )}
                <div style={{ marginLeft: '20px', padding: '10px 15px', border: '1px solid grey' }}>
                    <InputLabel id="domain">Domain</InputLabel>
                    <Select
                        labelId="domain"
                        id="domain-select"
                        value={filterDomain}
                        onChange={(a) => setFilterDomain(a.target.value as string)}
                    >
                        <MenuItem value="all" >All</MenuItem>
                        <MenuItem value="energy">Energy</MenuItem>
                        <MenuItem value="savings" >Savings</MenuItem>
                        <MenuItem value="solar">Solar</MenuItem>
                        <MenuItem value="lending">Lending</MenuItem>
                        <MenuItem value="super">Super</MenuItem>
                    </Select>
                </div>
            </div>
            <div>
                {insightData &&
                    insightData.map((a: gql.Insight) => {
                        return (
                            <div key={a.InsightID} className={css.container} style={insight_id === a.InsightID ? { backgroundColor: 'lightgreen' } : {}}>
                                <div className={css.rowLayout}>
                                    <strong>{a.Domain.toUpperCase()}</strong>
                                    <div>{  new Date(Date.parse(a.GeneratedAt.substring(0, 19)) + 36000000).toLocaleString()}</div>
                                    {a.Current == 'true' && (
                                        <Button onClick={() => handleDelete(a)}>Delete</Button>
                                    )}
                                    <a
                                        className={css.button}
                                        href={`/inspectResult?insightID=${a.InsightID}&userID=${a.UserID}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        RESULT
                                    </a>
                                    <a
                                        className={css.button}
                                        href={`https://demo.web.dev.acaciamoney.com/energy/openinsight/${a.UserID}/${a.InsightID}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        VIEW INSIGHT
                                    </a>
                                    {a.LogGroup !== '' && (
                                        <a
                                            className={css.button}
                                            href={`/inspectlog?group=${a.LogGroup}&stream=${a.LogStream}&search=${a.ExecID}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            LOG
                                        </a>
                                    )}
                                    {a.Error && <div className={css.summaryContainer}>ERROR CODE: {a.Error}</div>}
                                    {/* {a.BillId && <div className={css.summaryContainer}>BillID: {a.BillId}</div>} */}
                                    {a.Summary && (
                                        <>
                                            <div className={css.summaryContainer}>Provider: {a.Summary.ProviderName}</div>  
                                            <div className={css.summaryContainer}>Status: {a.Summary.Status}</div>
                                            <div className={css.summaryContainer}>MaxSave: {a.Summary.MaxDollar}</div>
                                            <div className={css.summaryContainer}>MaxLeaf: {a.Summary.MaxLeaf}</div>
                                            <div className={css.summaryContainer}>Source: {a.Summary.Source}</div>

                                        </>
                                    )}
                                </div>
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}

export default Insights
